module.exports = __webpack_public_path__ + "img/lower-bg.075a958b.png";